export default {
  formField: {
    address: {
      button: {
        text: 'Find address',
      },
      textInput: {
        placeholder: 'Postcode...',
      },
    },
    addressNoPostcode: {
      textInputLine1: {
        placeholder: 'Line 1...',
      },
      textInputLine2: {
        placeholder: 'Line 2...',
      },
      textInputTownCity: {
        placeholder: 'Town/city...',
      },
      textInputCounty: {
        placeholder: 'County...',
      },
    },
    apiCallbackField: {
      textInput: {
        placeholder: 'Enter a value...',
      },
    },
    datePicker: {
      dateInput: {
        placeholder: 'Select a date...',
      },
    },
    dvlaLookup: {
      button: {
        text: 'Get vehicle',
      },
      textInput: {
        placeholder: 'Registration number...',
      },
    },
    email: {
      textInputEmail: {
        placeholder: 'Email...',
      },
      textInputEmailConfirmation: {
        placeholder: 'Email confirmation...',
      },
    },
    emailAndPassword: {
      textInputEmail: {
        placeholder: 'Email...',
      },
      textInputEmailConfirmation: {
        placeholder: 'Email confirmation...',
      },
      textInputPassword: {
        placeholder: 'Password...',
      },
      textInputPasswordConfirmation: {
        placeholder: 'Password confirmation...',
      },
    },
    employersReferenceNumber: {
      textInputA: {
        placeholder: '123',
      },
      textInputB: {
        placeholder: 'XX12345',
      },
    },
    fileUpload: {
      button: {
        text: 'Choose file',
      },
      noFile: 'No file chosen',
    },
    name: {
      textInputFirstName: {
        placeholder: 'First name...',
      },
      textInputSurname: {
        placeholder: 'Surname...',
      },
    },
  },
  keyword: {
    additional: 'Additional',
    charge: 'Charge',
    choice: 'Choice',
    choices: 'Choices',
    condition: 'Condition',
    modifier: 'Modifier',
    modifiers: 'Modifiers',
    multipage: 'Multipage',
    quotation: 'Quotation',
    question: 'Question',
    questions: 'Questions',
    page: 'Page',
    pages: 'Pages',
    postQuotation: 'Post quotation',
    riskGroup: 'Risk group',
    riskGroups: 'Risk groups',
    rule: 'Rule',
    rules: 'Rules',
    table: 'Table',
    trigger: 'Trigger',
    triggers: 'Triggers',
    untitled: 'Untitled',
    validation: 'Validation',
    validations: 'Validations',
  },
  screen: {
    comparisonEditor: {
      source: {
        noComparison: 'No comparison selected.',
        noDifference: 'No differences found.',
      },
      visual: {
        notSupported: 'Visual comparisons are not currently supported.',
      },
    },
    mainEditor: {
      //
    },
    pageEditor: {
      //
    },
    sourceEditor: {
      error: {
        validation: 'Validation errors, please check below to find out more.',
      },
      table: {
        validationErrors: {
          heading: {
            field: 'Field',
            message: 'Message',
          },
        },
      },
    },
  },
  modal: {
    bulkAddQuestions: {
      selectQuestionCategory: {
        label: 'Question category',
      },
      selectQuestionType: {
        label: 'Question type',
      },
      textInputSystemId: {
        label: 'System ID',
        placeholder: 'System ID...',
      },
      textInputTitle: {
        label: 'Title',
        placeholder: 'Title...',
      },
      title: 'Bulk add questions',
    },
    deletePageConfirmation: {
      warning: 'Are you sure you want to delete this page?',
    },
    deleteQuestionConfirmation: {
      warning: 'Are you sure you want to delete this question?',
      warningTriggers: 'This question is used by a trigger in the following:',
      warningTriggerPages: 'This question is used by a trigger in the following pages:',
      warningTriggerQuestions: 'This question is used by a trigger in the following questions:',
      warningTriggerConfirm: 'The triggers tracking this question will also be deleted.',
    },
    deleteRiskGroupConfirmation: {
      warning: 'Are you sure you want to delete this risk group?',
    },
    editPage: {
      add: {
        title: 'Add page - {{ title }}',
      },
      edit: {
        title: 'Edit page - {{ title }}',
      },
      tab: {
        general: {
          showOn: {
            checkboxFirstPremiumQuotes: 'First premium quotes',
            checkboxMtaQuotes: 'MTA quotes',
            checkboxRenewalQuotes: 'Renewal quotes',
            title: 'Show on',
          },
          textInputPageTitle: {
            label: 'Page title',
            placeholder: 'Page title...',
          },
          textInputTabTitle: {
            label: 'Tab title',
            placeholder: 'Tab title...',
          },
          title: 'General',
        },
        triggers: {
          and: 'AND',
          if: 'IF',
          is: 'IS',
          textInputTestValue: {
            placeholder: 'Value...',
          },
          then: 'THEN',
          title: 'Triggers',
          restrictions: {
            childQuestion: 'Child question',
            multipageParent: 'MultiPage parent',
            tableParent: 'Table parent',
            thisQuestion: 'This question',
          },
        },
      },
    },
    editQuestion: {
      add: {
        title: 'Add question - {{ title }}',
      },
      edit: {
        title: 'Edit question - {{ title }}',
      },
      tab: {
        general: {
          buttonAddDescription: 'Add description',
          buttonAddHelpTip: 'Add help tip',
          options: {
            checkboxHiddenTrigger: 'Hidden',
            checkboxReadOnly: 'Read Only',
            checkboxRequired: 'Required',
            checkboxResetIfHidden: 'Reset If Hidden',
            checkboxSum: 'Sum',
            checkboxOnMatrix: 'On Matrix',
            title: 'Options',
          },
          selectQuestionCategory: {
            label: 'Question category',
          },
          selectQuestionType: {
            label: 'Question type',
          },
          showOn: {
            checkboxFirstPremiumQuotes: 'First premium quotes',
            checkboxMtaQuotes: 'MTA quotes',
            checkboxRenewalQuotes: 'Renewal quotes',
            title: 'Show on',
          },
          textAreaDescription: {
            label: 'Description',
            placeholder: 'Description...',
          },
          textAreaHelpTip: {
            label: 'Help tip',
            placeholder: 'Help tip...',
          },
          textInputSystemId: {
            label: 'System ID',
            placeholder: 'System ID...',
          },
          textInputTitle: {
            label: 'Title',
            placeholder: 'Title...',
          },
          title: 'General',
        },
        multiquestion: {
          tab: {
            charges: {
              selectCancellation: {
                label: 'Cancellation',
              },
              selectRateOrFee: {
                label: 'Rate or fee',
              },
              selectRiskGroup: {
                label: 'Risk group',
              },
              selectSourceColumn: {
                label: 'Source column',
              },
              setInRatingFile: 'Set in rating file',
              textInputDefault: {
                label: 'Default',
                placeholder: 'Default...',
              },
              textInputName: {
                label: 'Name',
                placeholder: 'Name...',
              },
              textInputSystemId: {
                label: 'System ID',
                placeholder: 'System ID...',
              },
              title: 'Charges',
            },
            modifiers: {
              selectCancellation: {
                label: 'Cancellation',
              },
              selectModifier: {
                label: 'Modifier',
              },
              selectRateOfFee: {
                label: 'Rate or fee',
              },
              selectRiskGroup: {
                label: 'Risk group',
              },
              textInputDefault: {
                label: 'Default',
                placeholder: 'Default...',
              },
              textInputName: {
                label: 'Name',
                placeholder: 'Name...',
              },
              textInputSystemId: {
                label: 'System ID',
                placeholder: 'System ID...',
              },
              title: 'Modifiers',
            },
            multipage: {
              selectKeyQuestion: {
                label: 'Key question',
              },
              textInputLinkText: {
                label: 'Link text',
                placeholder: 'Page...',
              },
              textInputMaxNumberOfPages: {
                label: 'Max number of pages',
                placeholder: '10...',
              },
              title: 'Multipage',
            },
            questions: {
              title: 'Questions',
            },
            table: {
              title: 'Table',
            },
          },
          title: 'Multiquestion',
        },
        rates: {
          selectCancellation: {
            label: 'Cancellation',
          },
          selectRiskGroup: {
            label: 'Risk group',
          },
          textInputInFull: {
            label: 'In full',
            placeholder: '0.01',
          },
          textInputRate: {
            label: 'Rate',
            placeholder: '1',
          },
          title: 'Rates',
        },
        triggers: {
          and: 'AND',
          if: 'IF',
          is: 'IS',
          textInputTestValue: {
            placeholder: 'Value...',
          },
          then: 'THEN',
          title: 'Triggers',
          restrictions: {
            childQuestion: 'Child question',
            multipageParent: 'MultiPage parent',
            tableParent: 'Table parent',
            thisQuestion: 'This question',
          },
        },
        validation: {
          if: 'IF',
          message: 'MESSAGE',
          textInputTestValue: {
            placeholder: 'Value...',
          },
          textInputWarningText: {
            placeholder: 'Message...',
          },
          title: 'Validation',
        },
        value: {
          checkboxAutoComplete: 'Add autocomplete ability to dropdown',
          checkboxSetAsToday: 'Set as today',
          labelDefaultValue: 'Default value',
          labelTimeAfter: 'Time after',
          labelTimeBefore: 'Time before',
          selectAllowedFileTypes: {
            label: 'Allowed file types',
          },
          selectDocumentTemplate: {
            label: 'Document template',
          },
          selectFileLookup: {
            label: 'File lookup',
          },
          selectTermsPolicyLength: {
            label: 'Term policy length',
          },
          selectPrivacyTemplate: {
            label: 'Privacy template',
          },
          selectTermsTemplate: {
            label: 'Terms template',
          },
          textInputChoiceName: {
            placeholder: 'Name...',
          },
          textInputChoiceValue: {
            placeholder: 'Value...',
          },
          textInputMaxDays: {
            endAdornment: 'Days',
            placeholder: '0',
          },
          textInputMaxMonths: {
            endAdornment: 'Months',
            placeholder: '0',
          },
          textInputMaxYears: {
            endAdornment: 'Years',
            placeholder: '0',
          },
          textInputMinDays: {
            endAdornment: 'Days',
            placeholder: '0',
          },
          textInputMinMonths: {
            endAdornment: 'Months',
            placeholder: '0',
          },
          textInputMinYears: {
            endAdornment: 'Years',
            placeholder: '0',
          },
          textInputPlaceholder: {
            label: 'Placeholder',
            placeholder: 'Placeholder...',
          },
          title: 'Value',
        },
      },
    },
    editRiskGroup: {
      add: {
        title: 'Add risk group - {{ title }}',
      },
      edit: {
        title: 'Edit risk group - {{ title }}',
      },
      tab: {
        general: {
          checkboxAddon: 'Add on',
          checkboxIncludeItemsOnBordereaux: 'Include items on bordereaux',
          checkboxIncludeTotalsOnBordereaux: 'Include totals on bordereaux',
          selectDefaultInsurer: {
            label: 'Default insurer',
          },
          textInputColour: {
            label: 'Colour',
            placeholder: '#ffcc00',
          },
          textInputName: {
            label: 'Name',
            placeholder: 'Name...',
          },
          textInputReportName: {
            label: 'Report name',
            placeholder: 'Report name...',
          },
          title: 'General',
        },
        modifiers: {
          selectCancellation: {
            label: 'Cancellation',
          },
          selectRateOrFee: {
            label: 'Rate or fee',
          },
          selectType: {
            label: 'Type',
          },
          textInputDisplayName: {
            label: 'Display name',
            placeholder: 'Display name...',
          },
          textInputName: {
            label: 'Name',
            placeholder: 'Name...',
          },
          title: 'Modifiers',
        },
      },
    },
    importQuestionSet: {
      body: 'Choose a JSON file to import (.json)',
      error: {
        json: 'Invalid or malformed JSON file.',
        validation: 'Validation failed, view the errors below.',
      },
      table: {
        validationErrors: {
          heading: {
            rootName: 'Page name / risk group',
            formName: 'Form name',
            message: 'Message',
          },
        },
      },
      title: 'Import question set',
      warning: 'WARNING: If you proceed any unsaved changes will be lost.',
    },
    publishActiveQuestionSetConfirmation: {
      title: 'Publish question set',
      warning:
        'WARNING: If you proceed this will overwrite the currently published question set.',
    },
    replacementRiskGroup: {
      replace: {
        error:
          'No other risk groups exist, create a new risk group to use as a replacement.',
        select: {
          label: 'Assign replacement risk group',
        },
      },
      table: {
        blockingCharges: {
          heading: {
            name: 'Name',
            chargeSystemId: 'Charge System ID',
          },
        },
        blockingModifiers: {
          heading: {
            name: 'Name',
            modfierSystemId: 'Modifier System ID',
          },
        },
        blockingRates: {
          heading: 'Calculation rate risk group',
        },
      },
      title: 'Risk group in use',
      warning:
        'This risk group is currently being used by existing questions, please manually update the questions or assign a replacement risk group from the options below.',
    },
    revertActiveQuestionSetConfirmation: {
      title: 'Cancel unsaved changes.',
      warning: 'WARNING: If you proceed any unsaved changes will be lost.',
    },
    switchActiveQuestionSetConfirmation: {
      title: 'Change of question sets',
      warning: 'WARNING: If you proceed any unsaved changes will be lost.',
    },
  },
  component: {
    header: {
      comparison: {
        button: {
          revert: 'Revert to this version',
        },
        current: {
          select: {
            label: 'Current',
          },
        },
        other: {
          select: {
            label: 'Other',
          },
        },
      },
      search: {
        placeholder: 'Search for a question...',
      },
      title: 'Editing questions for {{ schemeName }}',
    },
    saveControls: {
      getQuote: 'Get quote',
    },
  },
  toast: {
    error: {
      noMainRiskGroup: 'Risk group `Main` missing from question set.',
    },
  },
  tooltip: {
    addMultipageQuestion: 'Add multipage question',
    addQuestion: 'Add question',
    addTableQuestion: 'Add table question',
    bulkQuestionVerification: 'Bulk added questions need verifying',
    formatJson: 'Format JSON',
    pageHasTriggers: 'This page has triggers',
    questionHasHiddenTrigger:
      'This question has a trigger to permanently hide it',
    questionHasTriggers: 'This question has triggers',
    questionHasValidation: 'This question has validation',
    questionIsChargeSourceColumn:
      'This question is used in a charge source column',
    questionIsIncludedOnMatrix: 'This question will show on the matrix page',
    questionIsKey: 'This is the key question',
    questionIsReadOnly: 'This question is read only',
    questionIsRequired: 'This question is required',
    questionIsSum: 'This is question is a sum',
    questionIsUsedInTrigger: 'This is question is used in a trigger',
    riskGroupHasModifiers: 'This risk group has modifiers',
    riskGroupIsInUse: 'This risk group is in use',
    riskGroupIsNotInUse: 'This risk group is not in use',
    unsavedChanges: 'Unsaved changes',
  },
};
